import { PixelArt, PIXEL_KINDS } from "./PixelArt";
const INK = "#3B2350";

const Face = ({ cx = 50, cy = 55, s = 1 }) => (
  <g>
    <circle cx={cx - 10 * s} cy={cy} r={3.2 * s} fill={INK} />
    <circle cx={cx + 10 * s} cy={cy} r={3.2 * s} fill={INK} />
    <circle cx={cx - 9 * s} cy={cy - 1.2 * s} r={1 * s} fill="#fff" />
    <circle cx={cx + 11 * s} cy={cy - 1.2 * s} r={1 * s} fill="#fff" />
    <ellipse cx={cx - 17 * s} cy={cy + 7 * s} rx={5 * s} ry={3 * s} fill="#FF8FBF" opacity="0.7" />
    <ellipse cx={cx + 17 * s} cy={cy + 7 * s} rx={5 * s} ry={3 * s} fill="#FF8FBF" opacity="0.7" />
    <path d={`M${cx - 4 * s} ${cy + 6 * s} Q${cx} ${cy + 10 * s} ${cx + 4 * s} ${cy + 6 * s}`} stroke={INK} strokeWidth={2.2 * s} fill="none" strokeLinecap="round" />
  </g>
);

const stroke = { stroke: INK, strokeWidth: 3, strokeLinejoin: "round", strokeLinecap: "round" };

const ART = {
  heart: (
    <><path d="M50 86 C20 66 8 48 14 32 C20 16 42 14 50 30 C58 14 80 16 86 32 C92 48 80 66 50 86Z" fill="#FF7EB6" {...stroke} />
      <ellipse cx="30" cy="34" rx="6" ry="4" fill="#fff" opacity="0.6" transform="rotate(-30 30 34)" /><Face cy={50} s={0.9} /></>
  ),
  star: (
    <><path d="M50 10 L61 37 L90 39 L67 57 L75 86 L50 70 L25 86 L33 57 L10 39 L39 37Z" fill="#FFD66B" {...stroke} /><Face cy={52} s={0.8} /></>
  ),
  flower: (
    <>{[0, 72, 144, 216, 288].map((r) => (
        <ellipse key={r} cx="50" cy="26" rx="15" ry="19" fill="#F9A8D4" {...stroke} transform={`rotate(${r} 50 50)`} />
      ))}
      <circle cx="50" cy="50" r="17" fill="#FFE08A" {...stroke} /><Face cy={50} s={0.55} /></>
  ),
  bow: (
    <><path d="M50 50 C36 30 14 26 12 40 C10 56 32 64 50 50Z" fill="#FF7EB6" {...stroke} />
      <path d="M50 50 C64 30 86 26 88 40 C90 56 68 64 50 50Z" fill="#FF7EB6" {...stroke} />
      <path d="M46 54 L36 84 L46 78 L50 86 L54 78 L64 84 L54 54Z" fill="#F45B9C" {...stroke} />
      <circle cx="50" cy="50" r="8" fill="#F45B9C" {...stroke} /></>
  ),
  cloud: (
    <><path d="M26 74 C12 74 8 56 22 52 C20 36 40 30 48 40 C54 26 78 28 78 46 C92 46 94 74 76 74Z" fill="#E9E0FF" {...stroke} /><Face cy={58} s={0.8} /></>
  ),
  bunny: (
    <><ellipse cx="36" cy="26" rx="8" ry="20" fill="#fff" {...stroke} /><ellipse cx="64" cy="26" rx="8" ry="20" fill="#fff" {...stroke} />
      <ellipse cx="36" cy="27" rx="3.5" ry="13" fill="#FFB8D6" /><ellipse cx="64" cy="27" rx="3.5" ry="13" fill="#FFB8D6" />
      <ellipse cx="50" cy="62" rx="30" ry="25" fill="#fff" {...stroke} /><Face cy={62} s={0.8} /></>
  ),
  cat: (
    <><path d="M22 40 L24 12 L44 30 L56 30 L76 12 L78 40 C86 52 84 82 50 84 C16 82 14 52 22 40Z" fill="#C9B6FF" {...stroke} />
      <path d="M28 22 L30 34 L38 30Z" fill="#FFB8D6" /><path d="M72 22 L70 34 L62 30Z" fill="#FFB8D6" /><Face cy={58} s={0.85} /></>
  ),
  strawberry: (
    <><path d="M50 88 C22 76 14 50 22 38 C32 26 68 26 78 38 C86 50 78 76 50 88Z" fill="#FF6F9C" {...stroke} />
      <path d="M30 30 L40 18 L50 28 L60 18 L70 30 C60 36 40 36 30 30Z" fill="#7BD88F" {...stroke} />
      {[[34, 50], [66, 50], [40, 72], [60, 72], [50, 80]].map(([x, y]) => <ellipse key={`${x}${y}`} cx={x} cy={y} rx="1.8" ry="2.6" fill="#FFE08A" />)}
      <Face cy={56} s={0.6} /></>
  ),
  sparkle: (
    <><path d="M50 8 C54 36 64 46 92 50 C64 54 54 64 50 92 C46 64 36 54 8 50 C36 46 46 36 50 8Z" fill="#B794FF" {...stroke} />
      <path d="M82 14 C83 20 86 23 92 24 C86 25 83 28 82 34 C81 28 78 25 72 24 C78 23 81 20 82 14Z" fill="#FF9FCB" {...stroke} strokeWidth="2" /></>
  ),
  rainbow: (
    <>{[["#FF7EB6", 38], ["#FFD66B", 30], ["#9FE3B4", 22], ["#B794FF", 14]].map(([c, r]) => (
        <path key={c} d={`M${50 - r} 72 A${r} ${r} 0 0 1 ${50 + r} 72`} stroke={c} strokeWidth="8" fill="none" strokeLinecap="round" />
      ))}
      <ellipse cx="16" cy="74" rx="12" ry="8" fill="#fff" {...stroke} /><ellipse cx="84" cy="74" rx="12" ry="8" fill="#fff" {...stroke} /></>
  ),
  mushroom: (
    <><path d="M14 50 C14 20 86 20 86 50 Z" fill="#FF7EB6" {...stroke} />
      <circle cx="32" cy="38" r="5" fill="#fff" /><circle cx="56" cy="30" r="6" fill="#fff" /><circle cx="72" cy="42" r="4" fill="#fff" />
      <path d="M32 50 L68 50 L66 84 C60 88 40 88 34 84Z" fill="#FFF3E6" {...stroke} /><Face cy={66} s={0.55} /></>
  ),
  moon: (
    <><path d="M62 10 C34 14 18 40 28 66 C38 90 70 94 88 74 C60 78 42 50 62 10Z" fill="#FFE08A" {...stroke} />
      <Face cx={46} cy={58} s={0.6} /></>
  ),
  lightbulb: (
    <><path d="M50 10 C28 10 18 28 22 44 C25 56 36 60 36 70 L64 70 C64 60 75 56 78 44 C82 28 72 10 50 10Z" fill="#FFE08A" {...stroke} />
      <rect x="37" y="70" width="26" height="9" rx="3" fill="#C9B6FF" {...stroke} /><rect x="40" y="79" width="20" height="8" rx="4" fill="#B794FF" {...stroke} />
      <path d="M10 22 L18 26 M90 22 L82 26 M50 0 L50 4" {...stroke} stroke="#FF9FCB" />
      <ellipse cx="34" cy="28" rx="4" ry="7" fill="#fff" opacity="0.7" transform="rotate(30 34 28)" /><Face cy={42} s={0.7} /></>
  ),
  book: (
    <><path d="M50 26 C40 18 24 18 12 22 L12 80 C24 76 40 76 50 84 C60 76 76 76 88 80 L88 22 C76 18 60 18 50 26Z" fill="#FF9FCB" {...stroke} />
      <path d="M50 26 L50 84" {...stroke} /><path d="M18 30 C28 27 38 28 44 32 L44 74 C38 70 28 70 18 72Z" fill="#fff" />
      <path d="M82 30 C72 27 62 28 56 32 L56 74 C62 70 72 70 82 72Z" fill="#fff" /><Face cx={69} cy={52} s={0.5} />
      <path d="M24 40 L38 42 M24 50 L38 52 M24 60 L34 61" stroke="#C9B6FF" strokeWidth="3" strokeLinecap="round" /></>
  ),
  pen: (
    <><g transform="rotate(40 50 50)"><rect x="40" y="10" width="20" height="58" rx="6" fill="#B794FF" {...stroke} />
      <rect x="40" y="18" width="20" height="8" fill="#FF9FCB" {...stroke} /><path d="M40 68 L60 68 L50 90Z" fill="#FFF3E6" {...stroke} />
      <path d="M47 82 L53 82 L50 90Z" fill={INK} /><rect x="58" y="14" width="5" height="26" rx="2.5" fill="#FFD66B" {...stroke} strokeWidth="2" />
      <Face cy={44} s={0.45} /></g></>
  ),
  glasses: (
    <><path d="M8 40 L24 34 M92 40 L76 34" {...stroke} />
      <circle cx="30" cy="54" r="19" fill="#EDE7FE" {...stroke} /><circle cx="70" cy="54" r="19" fill="#EDE7FE" {...stroke} />
      <path d="M44 48 Q50 42 56 48" {...stroke} fill="none" />
      <path d="M20 46 L28 40 M60 46 L68 40" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
      <path d="M24 56 Q30 61 36 56 M64 56 Q70 61 76 56" {...stroke} fill="none" />
      <ellipse cx="22" cy="66" rx="5" ry="3" fill="#FF8FBF" opacity="0.7" /><ellipse cx="78" cy="66" rx="5" ry="3" fill="#FF8FBF" opacity="0.7" /></>
  ),
  coffee: (
    <><path d="M34 22 C30 16 38 12 34 6 M50 22 C46 16 54 12 50 6 M66 22 C62 16 70 12 66 6" stroke="#C9B6FF" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M74 42 C90 42 90 66 72 66" fill="none" {...stroke} strokeWidth="6" stroke={INK} /><path d="M74 42 C90 42 90 66 72 66" fill="none" stroke="#FF9FCB" strokeWidth="2.5" />
      <path d="M20 30 L80 30 L74 80 C72 88 28 88 26 80Z" fill="#FF9FCB" {...stroke} />
      <path d="M22 40 L78 40" stroke="#fff" strokeWidth="4" opacity="0.6" /><Face cy={58} s={0.75} /></>
  ),
  pencil: (
    <><g transform="rotate(-40 50 50)"><rect x="38" y="16" width="24" height="56" fill="#FFD66B" {...stroke} />
      <path d="M38 72 L62 72 L50 94Z" fill="#FFE9C9" {...stroke} /><path d="M46 86 L54 86 L50 94Z" fill={INK} />
      <rect x="38" y="6" width="24" height="12" rx="5" fill="#FF9FCB" {...stroke} /><rect x="38" y="16" width="24" height="6" fill="#C9B6FF" {...stroke} />
      <Face cy={46} s={0.5} /></g></>
  ),
  microscope: (
    <><path d="M16 88 L84 88" {...stroke} strokeWidth="5" /><path d="M26 88 C26 78 40 76 50 76 L70 76" fill="none" {...stroke} />
      <rect x="44" y="10" width="18" height="44" rx="6" fill="#C9B6FF" {...stroke} transform="rotate(-20 53 32)" />
      <rect x="40" y="56" width="34" height="8" rx="4" fill="#FF9FCB" {...stroke} />
      <path d="M70 30 C86 40 84 66 66 76" fill="none" {...stroke} strokeWidth="5" />
      <rect x="34" y="6" width="22" height="9" rx="4" fill="#FF7EB6" {...stroke} transform="rotate(-20 45 10)" />
      <Face cx={52} cy={32} s={0.42} /></>
  ),
  flask: (
    <><path d="M40 10 L60 10 L60 36 L84 78 C88 86 82 90 76 90 L24 90 C18 90 12 86 16 78 L40 36Z" fill="#fff" {...stroke} />
      <path d="M28 62 L72 62 L82 80 C84 85 80 86 76 86 L24 86 C20 86 16 85 18 80Z" fill="#C9B6FF" />
      <rect x="36" y="6" width="28" height="8" rx="4" fill="#FF9FCB" {...stroke} />
      <circle cx="44" cy="74" r="3" fill="#fff" /><circle cx="60" cy="68" r="2" fill="#fff" /><circle cx="54" cy="46" r="3" fill="#C9B6FF" />
      <Face cy={74} s={0.55} /></>
  ),
  notebook: (
    <><rect x="20" y="10" width="62" height="80" rx="8" fill="#9FE3B4" {...stroke} />
      <rect x="32" y="22" width="40" height="18" rx="4" fill="#fff" {...stroke} strokeWidth="2.5" />
      {[24, 40, 56, 72].map((y) => <rect key={y} x="12" y={y} width="16" height="6" rx="3" fill="#FFE08A" {...stroke} strokeWidth="2.5" />)}
      <path d="M38 30 L66 30" stroke="#FF9FCB" strokeWidth="3" strokeLinecap="round" /><Face cx={54} cy={60} s={0.65} /></>
  ),
  paperclip: (
    <><path d="M36 70 L36 28 C36 14 64 14 64 28 L64 76 C64 92 30 92 30 76 L30 34" fill="none" stroke={INK} strokeWidth="11" strokeLinecap="round" />
      <path d="M36 70 L36 28 C36 14 64 14 64 28 L64 76 C64 92 30 92 30 76 L30 34" fill="none" stroke="#FF9FCB" strokeWidth="6" strokeLinecap="round" />
      <path d="M48 34 L48 62" stroke={INK} strokeWidth="11" strokeLinecap="round" /><path d="M48 34 L48 62" stroke="#C9B6FF" strokeWidth="6" strokeLinecap="round" />
      <Face cx={50} cy={74} s={0.45} /></>
  ),
  magnifier: (
    <><path d="M62 62 L86 86" stroke={INK} strokeWidth="16" strokeLinecap="round" /><path d="M62 62 L86 86" stroke="#FF7EB6" strokeWidth="10" strokeLinecap="round" />
      <circle cx="42" cy="42" r="28" fill="#EDE7FE" {...stroke} strokeWidth="7" stroke={INK} /><circle cx="42" cy="42" r="28" fill="none" stroke="#B794FF" strokeWidth="3" />
      <path d="M26 34 C28 26 34 22 40 20" stroke="#fff" strokeWidth="4" fill="none" strokeLinecap="round" /><Face cx={42} cy={44} s={0.65} /></>
  ),
  apple: (
    <><path d="M50 30 C36 18 12 24 14 52 C16 76 34 90 50 82 C66 90 84 76 86 52 C88 24 64 18 50 30Z" fill="#FF6F9C" {...stroke} />
      <path d="M50 30 C50 22 52 14 56 8" {...stroke} fill="none" /><path d="M54 18 C62 8 76 10 78 14 C72 22 60 22 54 18Z" fill="#7BD88F" {...stroke} />
      <ellipse cx="30" cy="42" rx="4" ry="7" fill="#fff" opacity="0.6" transform="rotate(25 30 42)" /><Face cy={56} s={0.8} /></>
  ),
  gradcap: (
    <><path d="M28 46 L28 66 C28 76 72 76 72 66 L72 46" fill="#B794FF" {...stroke} />
      <path d="M50 18 L94 36 L50 54 L6 36Z" fill="#8E6BD8" {...stroke} />
      <path d="M50 36 L82 44 L82 66" {...stroke} stroke="#FFD66B" fill="none" /><circle cx="82" cy="70" r="5" fill="#FFD66B" {...stroke} strokeWidth="2.5" />
      <circle cx="50" cy="36" r="4" fill="#FFD66B" {...stroke} strokeWidth="2" /><Face cy={62} s={0.55} /></>
  ),
  diploma: (
    <><rect x="12" y="32" width="76" height="36" rx="6" fill="#FFF3E6" {...stroke} />
      <ellipse cx="12" cy="50" rx="7" ry="18" fill="#FFE9C9" {...stroke} /><ellipse cx="88" cy="50" rx="7" ry="18" fill="#FFE9C9" {...stroke} />
      <rect x="44" y="30" width="12" height="40" fill="#FF7EB6" {...stroke} />
      <path d="M50 70 L42 88 L50 82 L58 88Z" fill="#FF7EB6" {...stroke} strokeWidth="2.5" />
      <Face cx={28} cy={48} s={0.42} /><path d="M66 44 L80 44 M66 52 L80 52" stroke="#C9B6FF" strokeWidth="3" strokeLinecap="round" /></>
  ),
};

export const CUTE_KINDS = Object.keys(ART);
export const STICKER_GROUPS = [
  { label: "Cute & study", kinds: CUTE_KINDS },
  { label: "Pixel pack", kinds: PIXEL_KINDS },
];
export const STICKER_KINDS = [...CUTE_KINDS, ...PIXEL_KINDS];

export const StickerArt = ({ kind, className = "w-full h-full" }) =>
  PIXEL_KINDS.includes(kind) ? (
    <PixelArt kind={kind} className={className} />
  ) : (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true" style={{ overflow: "visible" }}>
      {ART[kind] || ART.heart}
    </svg>
  );
